// extracted by mini-css-extract-plugin
export default {"compressor":"kZRabShOMfw2wHZTocrD","headerAndMain":"QnRHTCRFqSbnyzpqPZVG"};